import { useState, useEffect } from 'react';
import '../styles/products.scss';
import Card from 'react-bootstrap/Card';
import Banner1 from '../assets/banner/banner6.webp';
import Banner2 from '../assets/banner/banner7.webp';
import Banner3 from '../assets/banner/banner8.jpg';
import { Link, useNavigate } from 'react-router-dom';

const CallToAction = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [currentMode, setCurrentMode] = useState('custom');

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    const role = localStorage.getItem('role');
    const savedMode = localStorage.getItem('user_mode') || 'custom';

    setIsLoggedIn(!!token);
    setUserRole(role);
    setCurrentMode(savedMode);
  }, []);

  const handleCTAClick = (type) => {
    // Artisan join should always go directly
    if (type === 'contact') {
      navigate('/artisan-join');
      return;
    }

    // Other actions require login
    if (!isLoggedIn) {
      navigate('/login', { state: { from: type } });
      return;
    }

    if (type === 'custom') {
      if (userRole === 'client') {
        navigate('/client-dashboard');
      } else if (userRole === 'artisan') {
        navigate('/artisan-dashboard');
      } else {
        navigate('/login');
      }
    } else if (type === 'ready-made') {
      navigate('/ready-made-products');
    }
  };

  const ctaCards = [
    {
      image: Banner1,
      title: 'Custom Furniture Design',
      description:
        'Bring your unique vision to life with personalized designs crafted just for you',
      buttonText: 'Start Custom Project',
      buttonIcon: '🎨',
      type: 'custom',
      features: [
        'Personalized Design',
        'Premium Materials',
        'Expert Craftsmanship',
      ],
      buttonPosition: 'bottom',
    },
    {
      image: Banner2,
      title: 'Ready-Made Collection',
      description:
        'Shop premium furniture available for immediate delivery. Quality pieces, ready when you are.',
      buttonText: 'Browse Collection',
      buttonIcon: '🛍️',
      type: 'ready-made',
      features: ['In Stock', 'Fast Delivery', 'Quality Guaranteed'],
      buttonPosition: 'bottom',
    },
    {
      image: Banner3,
      title: 'For Artisans & Makers',
      description:
        'Join our community of skilled artisans and showcase your work to thousands of customers',
      buttonIcon: '🎨',
      type: 'contact',
      features: [
        'Showcase Your Work',
        'Connect with Clients',
        'Grow Your Business',
      ],
      buttonText: 'Join as Artisan',
      buttonPosition: 'bottom',
    },
  ];

  return (
    <section className="cta-products">
      <div className="cta-header">
        <h2>Your Vision, Our Craftsmanship</h2>
        <p>
          Choose your path — create custom pieces or shop from our curated
          collection of ready-made furniture
        </p>
        <div className="header-badges">
          <span className="badge custom-badge">🎨 Custom Orders</span>
          <span className="badge ready-badge">🛍️ Ready-Made</span>
          {/* <span className="badge artisan-badge">👥 For Artisans</span> */}
        </div>
      </div>

      <div className="cta-products__content">
        {ctaCards.map((card, index) => (
          <Card className="cta-card" key={index}>
            <div className="cta-card__image-wrapper">
              <img src={card.image} alt={card.title} className="cta-image" />
              <div className="cta-card__overlay">
                <div className="overlay-content">
                  <div className="overlay-icon">{card.buttonIcon}</div>
                  <Card.Title className="overlay-title">
                    {card.title}
                  </Card.Title>
                  <p className="overlay-description">{card.description}</p>

                  <div className="feature-list">
                    {card.features.map((feature, idx) => (
                      <div key={idx} className="feature-item">
                        <span className="feature-check">✓</span>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* Button at the bottom */}
                  <div className="button-container">
                    <button
                      className="shop-btn"
                      onClick={() => handleCTAClick(card.type)}
                    >
                      <span className="btn-icon">{card.buttonIcon}</span>
                      {card.buttonText}
                      <span className="btn-arrow">→</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>

      {/* Quick Stats Section */}
      {/* <div className="cta-stats">
        <div className="stat-item">
          <div className="stat-number">500+</div>
          <div className="stat-label">Completed Projects</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">200+</div>
          <div className="stat-label">Skilled Artisans</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">1000+</div>
          <div className="stat-label">Happy Customers</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">24/7</div>
          <div className="stat-label">Customer Support</div>
        </div>
      </div> */}

      {/* Trust Badges */}
      {/* <div className="trust-badges">
        <span>🔒 Secure Payments</span>
        <span>✓ Verified Artisans</span>
        <span>🚚 Free Delivery Over KSh 5,000</span>
        <span>💳 M-Pesa & Card Accepted</span>
      </div> */}
    </section>
  );
};

export default CallToAction;

// import { useState, useEffect } from 'react';
// import '../styles/products.scss';
// import Card from 'react-bootstrap/Card';
// import Banner1 from '../assets/banner/banner6.webp';
// import Banner2 from '../assets/banner/banner7.webp';
// import { Link, useNavigate } from 'react-router-dom';

// const CallToAction = () => {
//   const navigate = useNavigate();
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [userRole, setUserRole] = useState(null);
//   const [currentMode, setCurrentMode] = useState('custom');

//   useEffect(() => {
//     const token = localStorage.getItem('access_token');
//     const role = localStorage.getItem('role');
//     const savedMode = localStorage.getItem('user_mode') || 'custom';

//     setIsLoggedIn(!!token);
//     setUserRole(role);
//     setCurrentMode(savedMode);
//   }, []);

//   const handleCTAClick = (type) => {
//     if (!isLoggedIn) {
//       navigate('/login', { state: { from: type } });
//       return;
//     }

//     if (type === 'custom') {
//       if (userRole === 'client') {
//         navigate('/client-dashboard');
//       } else if (userRole === 'artisan') {
//         navigate('/artisan-dashboard');
//       } else {
//         navigate('/login');
//       }
//     } else if (type === 'ready-made') {
//       navigate('/ready-made-products');
//     }
//   };

//   const ctaCards = [
//     {
//       image: Banner1,
//       title: 'Custom Furniture Design',
//       description: 'Bring your unique vision to life with personalized designs crafted just for you',
//       buttonText: 'Start Custom Project',
//       buttonIcon: '🎨',
//       type: 'custom',
//       features: ['Personalized Design', 'Premium Materials', 'Expert Craftsmanship']
//     },
//     {
//       image: Banner2,
//       title: 'Ready-Made Collection',
//       description: 'Shop premium furniture available for immediate delivery. Quality pieces, ready when you are.',
//       buttonText: 'Browse Collection',
//       buttonIcon: '🛍️',
//       type: 'ready-made',
//       features: ['In Stock', 'Fast Delivery', 'Quality Guaranteed']
//     }
//   ];

//   return (
//     <section className="cta-products">
//       <div className="cta-header">
//         <h2>Your Vision, Our Craftsmanship</h2>
//         <p>Choose your path — create custom pieces or shop from our curated collection of ready-made furniture</p>
//         <div className="header-badges">
//           <span className="badge custom-badge">🎨 Custom Orders</span>
//           <span className="badge ready-badge">🛍️ Ready-Made</span>
//         </div>
//       </div>

//       <div className="cta-products__content">
//         {ctaCards.map((card, index) => (
//           <Card className="cta-card" key={index}>
//             <div className="cta-card__image-wrapper">
//               <img src={card.image} alt={card.title} className="cta-image" />
//               <div className="cta-card__overlay">
//                 <div className="overlay-content">
//                   <div className="overlay-icon">{card.buttonIcon}</div>
//                   <Card.Title className="overlay-title">{card.title}</Card.Title>
//                   <p className="overlay-description">{card.description}</p>

//                   <div className="feature-list">
//                     {card.features.map((feature, idx) => (
//                       <div key={idx} className="feature-item">
//                         <span className="feature-check">✓</span>
//                         <span>{feature}</span>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="button-container">
//                     <button
//                       className="shop-btn"
//                       onClick={() => handleCTAClick(card.type)}
//                     >
//                       <span className="btn-icon">{card.buttonIcon}</span>
//                       {card.buttonText}
//                       <span className="btn-arrow">→</span>
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </Card>
//         ))}
//       </div>

//       {/* Quick Stats Section */}
//       <div className="cta-stats">
//         <div className="stat-item">
//           <div className="stat-number">500+</div>
//           <div className="stat-label">Completed Projects</div>
//         </div>
//         <div className="stat-item">
//           <div className="stat-number">200+</div>
//           <div className="stat-label">Skilled Artisans</div>
//         </div>
//         <div className="stat-item">
//           <div className="stat-number">1000+</div>
//           <div className="stat-label">Happy Customers</div>
//         </div>
//         <div className="stat-item">
//           <div className="stat-number">24/7</div>
//           <div className="stat-label">Customer Support</div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default CallToAction;
